var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',_vm._g(_vm._b({directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"tree",staticClass:"project-resource-tree",attrs:{"data":_vm.tree,"node-key":"id","check-strictly":"","show-checkbox":"","default-expand-all":"","props":{
    label: _vm.labelHandler,
    disabled: _vm.disableHandler
  }},scopedSlots:_vm._u([{key:"default",fn:function({ data, node }){return [_c('render-vnode',{attrs:{"vnode":_vm.getTreeItem(data, node)}})]}}])},'el-tree',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }